import React from 'react';
import { FormattedMessage } from 'react-intl';
export var ThankYou = function ThankYou() {
  return React.createElement("div", {
    className: "location-modal--thank-you"
  }, React.createElement("h2", {
    className: "location-modal__title"
  }, React.createElement(FormattedMessage, {
    id: "thank-you.title",
    defaultMessage: "Thank you"
  })), React.createElement("p", {
    className: "location-modal__subtitle"
  }, React.createElement(FormattedMessage, {
    id: "thank-you.subtitle",
    defaultMessage: "You\u2019ll be the first to know when we\u2019re available in your area."
  })));
};